module.exports = __webpack_public_path__ + "static/img/bg2@2x.212008ec.png";